import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function addCard(options) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, cardToken } = options;

    invariant(baseUrl, 'baseUrl is a required param of addCard()');
    invariant(brandId, 'brandId is a required param of addCard()');
    invariant(country, 'country is a required param of addCard()');
    invariant(uberToken, 'uberToken is a required param of addCard()');
    invariant(clientId, 'clientId is a required param of addCard()');
    invariant(cardToken, 'cardToken is a required param of addCard()');
    
    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wallet/card/gps`;

    const payload = { cardToken }

    return labelRequest(
        authenticatedRequest(
            new Request(url, { method: 'POST', headers: new Headers(headers), body: JSON.stringify(payload) }),
            uberToken,
            clientId,
            clientSecret,
        ),
        'addCard',
    );
}
